var React = require('react');

function IcnMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Menu-Icon-Artboard","transform":"translate(-95.000000, -83.000000)","fill":"#444444"},React.createElement("g",{"id":"Group","transform":"translate(95.000000, 83.000000)"},[React.createElement("rect",{"id":"Menu-Icon-1","x":"0","y":"0","width":"24","height":"2","rx":"1","key":0}),React.createElement("rect",{"id":"Menu-Icon-2","x":"0","y":"10","width":"24","height":"2","rx":"1","key":1}),React.createElement("rect",{"id":"Menu-Icon-3","x":"0","y":"20","width":"24","height":"2","rx":"1","key":2})])));
}

IcnMenu.defaultProps = {"width":"24px","height":"22px","viewBox":"0 0 24 22","version":"1.1"};

module.exports = IcnMenu;

IcnMenu.default = IcnMenu;
